import { useLocation } from 'react-router-dom';

/**
 * Hook pour détecter si l'utilisateur est actuellement dans le contexte d'une association
 * @returns { isInAssociation: boolean, associationSlug: string | undefined }
 */
export const useAssociationContext = () => {
  const location = useLocation();

  // Détecter si on est dans une route d'association
  const isInAssociation = location.pathname.includes('/app/association/') && 
                          !location.pathname.includes('/app/associations'); // Exclure la liste des associations

  // Extraire le slug depuis l'URL
  // Format attendu: /app/association/:slug/...
  let associationSlug: string | undefined = undefined;
  
  if (isInAssociation) {
    const match = location.pathname.match(/\/app\/association\/([^/]+)/);
    if (match && match[1]) {
      associationSlug = match[1];
    }
  }

  return { isInAssociation, associationSlug };
};

